module.exports = __webpack_public_path__ + "08_bob_brown.c4bac6d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/08_bob_brown.png
// module id = iUqQ
// module chunks = 0